
export const getUserInfo = () => {
    const userDataString = sessionStorage.getItem("userInfo");
    if (!userDataString) return null;            
    const userData = JSON.parse(userDataString);
    return {...userData.user, token:userData.token};
}

export const isAdmin = () => {
    const userDataString = sessionStorage.getItem("userInfo");
    if (!userDataString) return false;            
    const userData = JSON.parse(userDataString);
    return (userData.user.role == 'ADMIN' || userData.user.role == 'SUPERADMIN');
}